/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Embedding_Hint_BackgroundInputs */



/**
* | output |
* | --- |
* | "This may take a while. You can close this page — embedding continues in the background." |
*
* @param {Spaces_Embedding_Hint_BackgroundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_embedding_hint_background = /** @type {((inputs?: Spaces_Embedding_Hint_BackgroundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Embedding_Hint_BackgroundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dies kann eine Weile dauern. Sie können diese Seite schließen — die Einbettung läuft im Hintergrund weiter.")
	return /** @type {LocalizedString} */ ("This may take a while. You can close this page — embedding continues in the background.")
});